import { Component } from "react";
import { connect } from "react-redux";
import { getIndexedDbTables } from "../../redux/parameter/parameterActions";
import CustomizedTextField from "../Input/CustomizedTextField";
import TableWithoutPagination from "../Table/TableWithoutPagination";
import { formatBytesToSize } from "../../utils";

class System extends Component {
    constructor(props) {
        super(props);

        this.props.fetchData();
        this.state = {
            totalStorage: null,
            internetSpeed: navigator.connection.downlink,
            columns: [
                {
                    Header: "Tables IndexedDb",
                    columns: [
                        {
                            Header: "Nom",
                            id: "name",
                            accessor: "name",
                        },
                        {
                            Header: "Nb lignes",
                            id: "nbLines",
                            accessor: "nbLines",
                        },
                        {
                            Header: "Espace stockage",
                            id: "memorySpace",
                            accessor: "memorySpace",
                        },
                    ],
                },
            ],
        };
    }

    componentDidMount() {
        navigator.storage.estimate().then((navigatorStorage) => {
            this.setState({ totalStorage: navigatorStorage });
        });

        this.checkInternetSpeed();
    }

    checkInternetSpeed() {
        setInterval(() => {
            this.setState({ internetSpeed: navigator.connection.downlink });
        }, 1000);
    }

    render() {
        if (!this.state.totalStorage) return null;

        return (
            <div>
                <div className="card col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                    <div className="row control-margin-top">
                        <div className="col-lg-4 col-md-4 col-sm-6 col-12">
                            <CustomizedTextField
                                label="Stockage total occupé"
                                className="full_size light-disabled"
                                value={formatBytesToSize(this.state.totalStorage.usage)}
                            />
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-6 col-12">
                            <CustomizedTextField
                                label="Quota autorisé"
                                className="full_size light-disabled"
                                value={formatBytesToSize(this.state.totalStorage.quota)}
                            />
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-6 col-12">
                            <CustomizedTextField
                                className="full_size light-disabled"
                                label="Pourcentage stockage occupé"
                                value={(this.state.totalStorage.usage / this.state.totalStorage.quota).toFixed(2)}
                            />
                        </div>
                    </div>
                    <div className="row control-margin-top">
                        <div className="col-lg-4 col-md-4 col-sm-6 col-12">
                            <CustomizedTextField
                                label="Dont stockage indexedDB occupée"
                                className="full_size light-disabled"
                                value={formatBytesToSize(this.state.totalStorage.usageDetails.indexedDB)}
                            />
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-6 col-12">
                            <CustomizedTextField
                                label="Dont stockage SW occupé"
                                className="full_size light-disabled"
                                value={formatBytesToSize(
                                    this.state.totalStorage.usageDetails.serviceWorkerRegistrations
                                )}
                            />
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-6 col-12">
                            <CustomizedTextField
                                label="Dont stockage cache occupé"
                                className="full_size light-disabled"
                                value={formatBytesToSize(this.state.totalStorage.usageDetails.caches)}
                            />
                        </div>
                    </div>

                    <div className="row control-margin-top">
                        <div className="col-lg-4 col-md-4 col-sm-6 col-12">
                            <CustomizedTextField
                                className="full_size light-disabled"
                                label="Débit (Limité à 10Mbps par Google)"
                                value={this.state.internetSpeed + " Mbps"}
                            />
                        </div>
                    </div>
                </div>
                <div className="card col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                    <TableWithoutPagination
                        data={this.props.indexedDbTables}
                        columns={this.state.columns}
                        minRows={5}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        indexedDbTables: state.indexedDbTables,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchData: () => dispatch(getIndexedDbTables()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(System);
